const DEFAULT_SHARE_ORIGIN = 'https://www.ranktrivia.com'

function normalizeOrigin(value: string): string {
  return value.replace(/\/+$/, '')
}

export function getShareOrigin(): string {
  const configured = (import.meta.env.VITE_SHARE_BASE_URL as string | undefined)?.trim()
  if (configured) {
    return normalizeOrigin(configured)
  }

  if (typeof window !== 'undefined') {
    const origin = window.location.origin
    if (origin.startsWith('http://') || origin.startsWith('https://')) {
      return normalizeOrigin(origin)
    }
  }

  return DEFAULT_SHARE_ORIGIN
}
